<div class="row">
    <div class="col-sm-12">
        <core-card [actions]="['collapse']">
            <h4 class="card-title">{{'StartProject' | translate}}</h4>
            <div class="card-body">
                <form class="form">
                    <div class="row">
                        <div class="col-12">
                            <button type="submit" rippleeffect="" *ngIf="startProjectListButton === true"
                                class="btn btn-primary mr-1 waves-effect waves-float waves-light"
                                (click)="loadData()">{{'Search' | translate}}</button>
                            <button type="button" *ngIf="addStartProjectButton === true" class="btn btn-outline-success"
                                (click)="modalOpenVC(modalVC)" rippleEffect>
                                {{'Add' | translate}}
                            </button>
                        </div>
                    </div>
                </form>
                <div class="table-responsive" *ngIf="startProjectListButton === true">
                    <table class="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th class="text-center">{{'AssignedEmployee' | translate}}</th>
                                <th class="text-center">{{'CreationDateTime' | translate}}</th>
                                <th class="text-center">{{'ElapsedTime' | translate}}</th>
                                <th class="text-center">{{'Project' | translate}}</th>
                                <th class="text-center">{{'Done' | translate}}</th>
                                <th class="text-center">{{'Actions' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of startProjectResultList.data">
                                <td class="text-center">{{item.assignedEmployeeFullName}}</td>
                                <td class="text-center">{{item.creationDateTime | dateConverter:'DD/MM/yyyy HH:mm:ss'}}</td>
                                <td class="text-center">{{kalanzaman(item.creationDateTime)}} gün</td>
                                <td class="text-center">{{item.projectName}}</td>
                                <td class="text-center"><i class="feather"
                                        [ngClass]="{'icon-check' : (item.isDone === true), 'icon-x' : (item.isDone === false)}"></i>
                                </td>
                                <td class="text-center">
                                    <button type="button" tooltipClass="fadeInAnimation" placement="top"
                                        ngbTooltip="{{'StartProjectDetail' | translate}}"
                                        [routerLink]="['../start-project-detail-list', {startProjectId:item.id}]"><i
                                            data-feather="box"></i></button>
                                    <button *ngIf="projectCompletionOrOngoingButton === true"
                                        [disabled]="isBusy === true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'Done' | translate}}"
                                        (click)="updateIsDone(item.id, !item.isDone)"><i *ngIf="item.isDone"
                                            data-feather="play"></i>
                                        <i *ngIf="!item.isDone" data-feather="pause"></i></button>
                                    <button [disabled]="isBusy === true" type="button" tooltipClass="fadeInAnimation"
                                        placement="top" ngbTooltip="{{'History' | translate}}"
                                        (click)="demonstrateHistory(historyModal, item.id)"><i
                                            class="fa fa-history"></i></button>
                                    <button [disabled]="isBusy === true" *ngIf="deleteStartProjectButton === true"
                                        type="button" tooltipClass="fadeInAnimation" placement="top"
                                        ngbTooltip="{{'Delete' | translate}}"
                                        (click)="openAlertModal(modalDanger, item.id)"><i
                                            data-feather="trash"></i></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </core-card>
    </div>
</div>
<ng-template #modalVC let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{titleText | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <form class="form">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="projectDropdown">{{'Project' | translate}}</label>
                        <ng-select [virtualScroll]="true" id="projectDropdown" name="projectDropdown"
                            [items]="projectList" class="ng-select-size-sm" [(ngModel)]="customerProjectId"
                            [ngClass]="{'is-invalid' : (customerProjectIdIsInvalid === true)}" bindLabel="name"
                            bindValue="id">
                        </ng-select>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <app-assign [assignedEmployeeId]="assignedEmployeeId" [token]="token"
                            [assignedEmployeeFullName]="assignedEmployee.fullName"
                            [assignedEmployeePersonalPictureFileName]="assignedEmployee.personalPictureFileName"
                            [employeeDropdown]="employeeDropdown" (employeeAssigned)="assigned($event)"></app-assign>
                    </div>
                </div>
                <div class="col-12">
                    <button type="submit" rippleeffect="" [disabled]="isBusy === true"
                        class="btn mr-1 waves-effect waves-float waves-light btn-success"
                        (click)="submit()">{{submitButtonText | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<ng-template #modalDanger let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'Alert' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        {{utility.AlertModalDeleteMessage | translate}}
    </div>
    <div class="modal-footer">
        <button type="submit" rippleeffect="" [disabled]="isBusy === true"
            class="btn btn-danger mr-1 waves-effect waves-float waves-light" (click)="delete()">{{'Delete' |
            translate}}</button>
    </div>
</ng-template>
<ng-template #historyModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">{{'History' | translate}}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
        <app-project-history [mode]="''" [id]="startProjectIdForHistory"></app-project-history>
    </div>
</ng-template>
<app-alert [result]="result"></app-alert>